// eslint-disable-next-line no-restricted-imports
import { LinearGradient } from 'expo-linear-gradient';
import { styled } from 'dripsy';

export default styled(LinearGradient)();
